import {
  AmethystClient,
  type KycSessionAttachmentDto,
} from '@/integrations/Immersve/AmethystClient';

export const MINIMUM_TTL_IN_MILLIS = 1000 * 60 * 5; // 5mins
interface KycSessionAttachmentProps {
  type: string;
  fileId: string;
}

export type attachmentStatus = 'uploaded' | 'deleted';

export class KycSessionAttachment {
  type: string;
  fileId: string;
  expiry?: Date;
  fileName?: string;
  status?: attachmentStatus;

  constructor(props: KycSessionAttachmentProps) {
    this.type = props.type;
    this.fileId = props.fileId;
  }

  isExpired() {
    if (!this.expiry) {
      return false;
    }

    const expiresAt = new Date(this.expiry);
    expiresAt.setTime(expiresAt.getTime() - MINIMUM_TTL_IN_MILLIS);

    return expiresAt.getTime() < new Date().getTime();
  }

  async loadFileMetadata() {
    const file = await new AmethystClient().getFileUpload(this.fileId);
    if (!file || file?.status === 'deleted' || file?.status === 'deleting') {
      this.status = 'deleted';
      return undefined;
    }
    this.expiry = file?.expiresAt ? new Date(file.expiresAt) : undefined;
    this.fileName = file?.fileName;
    this.status = 'uploaded';
  }

  static createProofOfAddressAttachment(attachment: KycSessionAttachmentDto) {
    return new KycSessionAttachment({
      ...attachment,
    });
  }
}
